import { Amplify } from 'aws-amplify';

// Configure AWS Amplify with environment variables - absolute minimal config
const awsConfig = {
  aws_project_region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  aws_cognito_region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID || 'default-user-pool-id',
  aws_user_pools_web_client_id: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID || 'default-client-id',
  oauth: {},
  aws_cognito_identity_pool_id: process.env.REACT_APP_AWS_IDENTITY_POOL_ID || 'default-identity-pool-id'
};

// Debug: Log configuration values
console.log('AWS Configuration:', {
  region: process.env.REACT_APP_AWS_REGION,
  userPoolId: process.env.REACT_APP_AWS_USER_POOLS_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  cognitoDomain: process.env.REACT_APP_AWS_COGNITO_DOMAIN,
  identityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID
});

// Configure Amplify with minimal config - empty oauth to prevent errors
try {
  Amplify.configure(awsConfig);
  console.log('Amplify configured successfully');
} catch (error) {
  console.error('Amplify configuration error:', error);
  // Fallback: try without any oauth config
  try {
    const fallbackConfig = {
      aws_project_region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      aws_cognito_region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID || 'default-user-pool-id',
      aws_user_pools_web_client_id: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID || 'default-client-id'
    };
    Amplify.configure(fallbackConfig);
    console.log('Amplify configured with fallback');
  } catch (fallbackError) {
    console.error('Fallback configuration also failed:', fallbackError);
  }
}

// Export configured Amplify
export { Amplify };

export default awsConfig;
